<template>

  <div v-if="softRiskControlUrl">
    <div class="txms-dialog txms-check-apl-renewal" role="dialog" aria-labelledby="dialog-title" aria-modal="true">
      <div class="txms-dialog__hd">
        <h3 class="title" ref="title">请完成验证</h3>
        <div class="txms-dialog__close" @click="closeRiskControl">
        <i class="i_close"></i>
      </div>
    </div>
      <div class="txms-dialog__bd" :style="styleObject">
        <iframe ref="softRiskControl" :src="softRiskControlUrl" frameborder="0" width="100%" height="100%"></iframe>
      </div>
    </div>
    <div class="weui-mask"></div>
  </div>

</template>
<style>
</style>
<script>
import { mapActions } from "vuex"
import * as reportDict from "../../constants/report-dictonary"
export default {
  props: ["softRiskControlUrl", "buyParams", "hashQuery"],
  data() {
    return {
      styleObject: {
        height: "250px"
      }
    }
  },
  mounted() {
    let self = this
    window.addEventListener("message", e => {
      let iframe = self.$refs.softRiskControl
      if (e.source && e.source === (iframe && iframe.contentWindow)) {
        let res
        try {
          res = JSON.parse(e.data)
        } catch (e) {
          console.log(e)
        }

        if (res.action == "setSize") {
          console.log(res.data.h5_height)
          self.styleObject.height = res.data.h5_height + "px"
        } else if (res.action == "setTitle") {
          self.$refs.title.textContent = res.data.title
        } else if (res.action == "callback") {
          self.handleSoftRiskControlRePay({ buyParams: self.buyParams, fkParams: res.data, query: self.hashQuery })
        }
      }
    })
  },
  methods: {
    closeRiskControl() {
      this.clearSoftRiskControl()
      this.reportUserAction({
        iformat: reportDict.CLICK.RISK_CONTROL_CLOSE
      })
    },
    ...mapActions(["handleSoftRiskControlRePay", "clearSoftRiskControl", "reportUserAction"])
  }
}
</script>
